import React from 'react';
import Button from '../../../components/ui/Button';

const NavigationButtons = ({ 
  currentStep, 
  totalSteps, 
  onPrevious, 
  onNext, 
  onSave,
  isValid,
  isSaving 
}) => {
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === totalSteps;

  return (
    <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between gap-3 md:gap-4">
      <div className="flex items-center gap-3">
        {!isFirstStep && (
          <Button
            variant="outline"
            onClick={onPrevious}
            iconName="ChevronLeft"
            iconPosition="left"
            className="flex-1 sm:flex-initial"
          >
            Previous
          </Button>
        )}
        <Button
          variant="ghost"
          onClick={onSave}
          loading={isSaving}
          iconName="Save"
          iconPosition="left"
          className="flex-1 sm:flex-initial"
        >
          Save Progress
        </Button>
      </div>

      <Button
        variant={isLastStep ? "success" : "default"}
        onClick={onNext}
        disabled={!isValid}
        iconName={isLastStep ? "Check" : "ChevronRight"}
        iconPosition="right"
        className="flex-1 sm:flex-initial"
      >
        {isLastStep ? 'Complete Setup' : 'Next Step'}
      </Button>
    </div>
  );
};

export default NavigationButtons;